import React from "react";
import { Button } from "semantic-ui-react";
import { WidgetProps } from "../types";
import Prompt from "../Prompt";
import Summary, { SummaryField, SummaryText, Actions } from "../Summary";

/**
 * "Why am I designing my life?" — three short prompts.
 *
 * This question's stored description is the placeholder "Nothing", so the
 * instruction lives here instead. The field labels are the real prompts.
 */
const PROMPT = "Before you start, a few words on why you're here.";

const FIELDS = [
  { key: "taking_course", label: "Why are you taking this course?" },
  { key: "love", label: "What do you love about your life right now?" },
  { key: "redesign", label: "What would you most like to redesign?" },
];

const Motivation: React.FC<WidgetProps> = ({
  payload,
  update,
  submit,
  submitting,
  finished,
  question,
  currentUser,
}) => {
  const complete = FIELDS.every((f) => (payload[f.key] || "").trim().length > 1);

  if (finished) {
    return (
      <Summary question={question} currentUser={currentUser} prompt={PROMPT}>
        {FIELDS.map((field) => (
          <SummaryField key={field.key} label={field.label}>
            <SummaryText>{payload[field.key]}</SummaryText>
          </SummaryField>
        ))}
      </Summary>
    );
  }

  return (
    <div className="ui form assignment-form">
      <Prompt question={question} currentUser={currentUser} fallback={PROMPT} />

      {FIELDS.map((field) => (
        <div className="ix-section" key={field.key}>
          <div className="ix-label">{field.label}</div>
          <div className="field">
            <textarea
              rows={3}
              value={payload[field.key] || ""}
              onChange={(e) => update({ ...payload, [field.key]: e.target.value })}
            />
          </div>
        </div>
      ))}

      <Actions>
        <Button
          primary
          circular
          className="challenge-submit"
          disabled={!complete || submitting}
          loading={submitting}
          onClick={submit}
        >
          Submit
        </Button>
      </Actions>
    </div>
  );
};

export default Motivation;
